<template>
  <div>
    <!-- Feature Area Starts -->
    <section class="feature-area" style="padding: 20px 0">
      <div class="container">
        <el-divider content-position="center">基本信息</el-divider>
        <div>
          <div class="base-info">
            <div class="base-items">
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">应聘学科/岗位:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.gangWei" placeholder="必选" size="small">
                      <el-option label="语文" value="语文"></el-option>
                      <el-option label="数学" value="数学"></el-option>
                      <el-option label="英语" value="英语"></el-option>
                      <el-option label="物理" value="物理"></el-option>
                      <el-option label="化学" value="化学"></el-option>
                      <el-option label="生物" value="生物"></el-option>
                      <el-option label="政治" value="政治"></el-option>
                      <el-option label="历史" value="历史"></el-option>
                      <el-option label="地理" value="地理"></el-option>
                      <el-option label="心理" value="心理"></el-option>
                      <el-option label="音乐" value="音乐"></el-option>
                      <el-option label="体育" value="体育"></el-option>
                      <el-option label="美术" value="美术"></el-option>
                      <el-option label="科学" value="科学"></el-option>
                      <el-option label="信息技术(网络工程、计算机科学与技术专业优先)" value="信息技术"></el-option>

                      <el-option label="通用技术" value="通用技术"></el-option>
                      <el-option label="物理实验员" value="物理实验员"></el-option>
                      <el-option label="化学实验员" value="化学实验员"></el-option>
                      <el-option label="生物实验员" value="生物实验员"></el-option>
                      <el-option label="卫生与健康教育(医学专业)" value="卫生与健康教育"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">申请任教学段:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.teachStage" placeholder="必选" size="small">
                      <el-option label="高中" value="高中"></el-option>
                      <el-option label="初中" value="初中"></el-option>
                      <el-option label="小学" value="小学"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">姓名:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.name" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">性别:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.sex" placeholder="必选" size="small">
                      <el-option label="男" value="男"></el-option>
                      <el-option label="女" value="女"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">民族:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.nation" placeholder="必选" size="small">
                      <el-option v-for="nation in nations" :label="nation" :value="nation" :key="nation"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">身份证号:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.idCard" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">出生日期:</div>
                  <div class="item-info">
                    <el-date-picker v-model="currentObject.birthday" type="date" placeholder="必选" size="small"
                      style="width: 200px">
                    </el-date-picker>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">手机号:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.phone" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">是否在编:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.zaiBian" placeholder="必选" size="small">
                      <el-option label="否" value="否"></el-option>
                      <el-option label="是" value="是"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">是否在职:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.zaiZhi" placeholder="必选" size="small">
                      <el-option label="否" value="否"></el-option>
                      <el-option label="是" value="是"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">计算机等级:</div>
                  <div class="item-info">
                    <el-select v-model="currentObject.computerGrade" placeholder="必选" size="small" clearable>
                      <el-option label="一级" value="一级"></el-option>
                      <el-option label="二级" value="二级"></el-option>
                      <el-option label="三级" value="三级"></el-option>
                      <el-option label="四级" value="四级"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">政治面貌:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.zhengZhi" size="small" placeholder="必选"></el-input>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">籍贯:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.jiGuan" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">身高:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.height" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>
              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">家庭地址:</div>
                  <div class="item-info">
                    <el-input v-model="currentObject.homeAddress" size="small" placeholder="必填"></el-input>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">本科毕业时间:</div>
                  <div class="item-info">
                    <el-date-picker v-model="currentObject.benKeTime" type="date" placeholder="必选" size="small"
                      style="width: 200px">
                    </el-date-picker>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">研究生毕业时间:</div>
                  <div class="item-info">
                    <el-date-picker v-model="currentObject.yanJiuTime" type="date" placeholder="" size="small"
                      style="width: 200px">
                    </el-date-picker>
                  </div>
                </div>
              </div>

              <div class="item-right">
                <div class="item flex-item">
                  <div class="item-name flex-item">博士生毕业时间:</div>
                  <div class="item-info">
                    <el-date-picker v-model="currentObject.boShiTime" type="date" size="small" style="width: 200px">
                    </el-date-picker>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
        <div class="base-info">

          <div class="base-items" style="margin: 50px;">
            <div>照片</div>
            <el-upload class="avatar-uploader" style="margin-left:20px;border: 1px dashed #d9d9d9;"
              action="/api/file/upload" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              :headers="headers">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" style="max-width: 200px;max-height: 200px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <el-divider content-position="center">教育背景</el-divider>

        <div class="base-info">
          <div class="base-items">
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">毕业院校:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.biYeSchool" size="small" placeholder="必填"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">学历:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.xueLi" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">专业:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.zhuanYe" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">本科毕业院校:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.benkeSchool" size="small" placeholder="必填"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">本科专业:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.benkezhuanYe" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>


            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">是否师范类毕业生:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.shiFanSheng" placeholder="必选" size="small">
                    <el-option label="否" value="否"></el-option>
                    <el-option label="是" value="是"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">是否应届毕业生:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.yingJieSheng" placeholder="必选" size="small">
                    <el-option label="否" value="否"></el-option>
                    <el-option label="是" value="是"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">毕业年月:</div>
                <div class="item-info">
                  <el-date-picker v-model="eduInfo.biYeTime" type="date" placeholder="必选" size="small"
                    style="width: 200px">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">研究、博士生毕业院校:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.boShiSchool" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">研究、博士生专业:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.boShiZhuanYe" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">英语等级:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.englishLevel" placeholder="必选" size="small">
                    <el-option label="四级" value="四级"></el-option>
                    <el-option label="六级" value="六级"></el-option>
                    <el-option label="专四" value="专四"></el-option>
                    <el-option label="专八" value="专八"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">平均学分绩点:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.avgScore" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">综合排名:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.zongHeOrder" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">参与排名人数:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.orderNumber" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">普通话等级:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.chineseLevel" placeholder="必选" size="small">
                    <el-option label="一甲" value="一甲"></el-option>
                    <el-option label="一乙" value="一乙"></el-option>
                    <el-option label="二甲" value="二甲"></el-option>
                    <el-option label="二乙" value="二乙"></el-option>
                    <el-option label="二级以下" value="二级以下"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">专业技术职称:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.zhuanYeZhiCheng" placeholder="必选" size="small">
                    <el-option label="无" value="无"></el-option>
                    <el-option label="正高级教师" value="正高级教师"></el-option>
                    <el-option label="高级教师" value="高级教师"></el-option>
                    <el-option label="一级教师" value="一级教师"></el-option>
                    <el-option label="二级教师" value="二级教师"></el-option>
                    <el-option label="三级教师" value="三级教师"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">曾带奥赛学科:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.aoShuXueKe" placeholder="必选" size="small">
                    <el-option label="无" value="无"></el-option>
                    <el-option label="数学" value="数学"></el-option>
                    <el-option label="物理" value="物理"></el-option>
                    <el-option label="化学" value="化学"></el-option>
                    <el-option label="生物" value="生物"></el-option>
                    <el-option label="信息技术" value="信息技术"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">教师资格证类型:</div>
                <div class="item-info">
                  <el-select v-model="eduInfo.teacherCertificateType" placeholder="必选" size="small">
                    <el-option label="无" value="无"></el-option>
                    <el-option label="幼儿园教师资格证" value="幼儿园教师资格证"></el-option>
                    <el-option label="小学教师资格证" value="小学园教师资格证"></el-option>
                    <el-option label="初级中学教师资格证" value="初级中学教师资格证"></el-option>
                    <el-option label="高级中学教师资格证" value="高级中学教师资格证"></el-option>
                    <el-option label="中等职业学校教师资格证" value="中等职业学校师资格证"></el-option>
                    <el-option label="中等职业学校实习指导教师资格证" value="中等职业学校实习指导教师资格证"></el-option>
                    <el-option label="高等学校教师资格证" value="高等学校教师资格证"></el-option>
                    <el-option label="成人/大学教育的教师资格证" value="成人/大学教育的教师资格证"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">毕业高中:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.gaoZhongSchool" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">高考分数:</div>
                <div class="item-info">
                  <el-input v-model="eduInfo.gaoKaoScore" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-divider content-position="center">工作/实习经历</el-divider>
        <div class="create-buttom">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addWorks">添加经历</el-button>
        </div>

        <div class="base-info" v-for="(item, index) in workInfos" :key="index">
          <div class="base-items">
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">
                  工作单位{{ workInfos.length - index }}:
                </div>
                <div class="item-info">
                  <el-input v-model="item.company" size="small" placeholder="必填" style="width: 200px"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">开始日期:</div>
                <div class="item-info">
                  <el-date-picker v-model="item.startTime" placeholder="必填" size="small" style="width: 200px">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">结束日期:</div>
                <div class="item-info">
                  <el-date-picker v-model="item.endTime" placeholder="必填" size="small" style="width: 200px">
                  </el-date-picker>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">工作岗位:</div>
                <div class="item-info">
                  <el-input v-model="item.gangWei" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">工作职位:</div>
                <div class="item-info">
                  <el-input v-model="item.zhiWei" placeholder="必填" size="small"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">工作内容:</div>
                <div class="item-info">
                  <el-input v-model="item.workContent" placeholder="必填" size="small" type="textarea"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item"></div>
                <div class="item-info">
                  <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteWork(item)">删除</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-divider content-position="center">获得奖励</el-divider>

        <div class="base-info">
          <div class="base-items">
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">奖励(级别最高)１:</div>
                <div class="item-info">
                  <el-input v-model="reword.jiangLiFirst" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">奖励(级别次之)2:</div>
                <div class="item-info">
                  <el-input v-model="reword.jiangLiSecond" size="small"></el-input>
                </div>
              </div>
            </div>
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">奖励(级别次之)3:</div>
                <div class="item-info">
                  <el-input v-model="reword.jiangLiThird" size="small"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">职务(级别最高)１:</div>
                <div class="item-info">
                  <el-input v-model="reword.jobFirst" size="small"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">职务(级别次之)2:</div>
                <div class="item-info">
                  <el-input v-model="reword.jobSecond" size="small"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">大学期间参与社团:</div>
                <div class="item-info">
                  <el-input v-model="reword.daXueSheTuan" size="small"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="base-info">
          <div class="base-items">
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">其他奖励:</div>
                <div class="item-info">
                  <el-input v-model="reword.otherReward" size="small" type="textarea"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">奖励介绍:</div>
                <div class="item-info">
                  <el-input v-model="reword.resumeInfo" size="small" type="textarea"></el-input>
                </div>
              </div>
            </div>
          </div>

          <!-- 第三列 -->
          <div class="base-items">
            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">其他职务:</div>
                <div class="item-info">
                  <el-input v-model="reword.otherJob" size="small" type="textarea"></el-input>
                </div>
              </div>
            </div>

            <div class="item-right">
              <div class="item flex-item">
                <div class="item-name flex-item">备注:</div>
                <div class="item-info">
                  <el-input v-model="reword.remark" size="small" type="textarea"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="create-buttom" style="margin: 50px">
          <el-button type="primary" @click="updateResume">提交投递</el-button>
        </div>
      </div>
    </section>
    <div style="height: 300px"></div>
    <!-- Feature Area End -->
  </div>
</template>

<script>
import { add, getUserResume } from "@/api/resume";
export default {
  data() {
    return {
      name: "",
      currentObject: {},
      eduInfo: {},
      workInfos: [],
      workInfo: {
        company: "",
        gangWei: "",
        zhiWei: "",
        startTime: "",
        endTime: "",
        workContent: "",
      },
      imageUrl:'',
      reword: {},
      headers:{token:localStorage.getItem('token')},
      nations:['汉族', '壮族', '回族', '满族', '维吾尔族', '苗族', '彝族', '土家族', '藏族', '蒙古族', '侗族', '布依族', '瑶族', '白族', '朝鲜族', '哈尼族', '黎族', '哈萨克族', '傣族', '畲族', '傈僳族', '东乡族', '仡佬族', '拉祜族', '佤族', '水族', '纳西族', '羌族', '土族', '仫佬族', '锡伯族', '柯尔克孜族', '景颇族', '达斡尔族', '撒拉族', '布朗族', '毛南族', '塔吉克族', '普米族', '阿昌族', '怒族', '鄂温克族', '京族', '基诺族', '德昂族', '保安族', '俄罗斯族', '裕固族', '乌孜别克族', '门巴族', '鄂伦春族', '独龙族', '赫哲族', '高山族', '珞巴族', '塔塔尔族']
    };
  },
  mounted() {
    this.doGetUserResume();
  },
  methods: {
    doGetUserResume() {
      getUserResume().then((res) => {
        this.currentObject = res.data.data;
        if (this.currentObject.eduInfo) {
          this.eduInfo = this.currentObject.eduInfo;
        }
        if (this.currentObject.workInfos) {
          this.workInfos = this.currentObject.workInfos;
        }
        this.imageUrl = this.currentObject.imageUrl;

        this.reword = this.currentObject.rewardInfo;
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    addWorks() {
      if (this.workInfos.length >= 5) {
        this.$message.error("工作经历超限");
        return;
      }
      var temp = Object.assign({}, this.workInfo); // copy object
      this.workInfos.push(temp);
    },
    deleteWork(item) {
      this.workInfos = this.workInfos.filter((e) => e !== item);
    },
    updateResume() {
      this.currentObject.works = this.workInfos;
      this.currentObject.imageUrl = this.imageUrl;
      this.currentObject.rewardInfo = this.reword;
      this.currentObject.eduBaseInfo = this.eduInfo;
      add(this.currentObject).then((res) => {
        if (res.data.errorCode === "0") {
          this.$notify({
            title: "成功",
            message: res.data.message,
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            path: "/",
            query: {},
          });
        } else {
          this.$notify.error({
            title: "错误",
            message: res.data.message,
          });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if(res.errorCode==='0'){
        this.imageUrl = res.data;
      }else{
        this.$message.error('上传失败')
      }
      
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  },
};
</script>


<style  scoped>
.base-info {
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-wrap: wrap; */
}

.base-items {
  /* width: 370px; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: flex-end; */
}

.item {
  margin: 10px 0;
  /* width: 400px; */
}

.item-right {
  width: 370px;
  display: flex;
  justify-content: flex-end;
  /* align-self: center; */
}

.item .item-name {
  margin-right: 10px;
}

.item .item-info {
  margin-right: 10px;
  width: 200px;
}

.flex-item {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-self: center;
}

.create-buttom {
  display: flex;
  align-self: center;
  justify-content: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  /* width: 178px;
  height: 178px; */
  display: block;
}
</style>





// WEBPACK FOOTER //
// Home2.vue?1ce03bf8